export default __webpack_public_path__ + "static/media/NO.06230628.svg";